import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup} from '@angular/forms';
import {TrustiiService} from 'src/app/services/trustii.service';
import {SessionService} from 'src/app/services/session.service';
import {DataService} from 'src/app/services/data.service';
import {fromEvent} from 'rxjs';
import {map, debounceTime} from 'rxjs/operators';
import { DialogService } from 'src/app/services/dialog.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  resizeEvent: any;
  sidebar = 'desktop';
  form: FormGroup;
  error: string;
  modelText = null;
  data = null;
  isSessionAvailable = false;
  user = 'Options';
  isUniversity = false;
  isDs = false;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private trustiiService: TrustiiService,
    public dataService: DataService,
    public sessionService: SessionService,
    private dialogService: DialogService
  ) {}

  ngOnInit() {
    // Check if we display sidebar by default
    this.sidebarDisplayByUserAgent();
    this.isUniversity =
      this.sessionService.getVendor() &&
      this.sessionService.getVendor().isUniversity === 'yes'
        ? true
        : false;

    this.resizeEvent = fromEvent(window, 'resize').pipe(
      map(() => {
        return true;
      }),
      debounceTime(200)
    );

    this.resizeEvent.subscribe((data: boolean) => {
      this.sidebarDisplayByUserAgent();
    });

    this.form = this.formBuilder.group({
      dataset: [''],
    });

    this.sessionService.tokenData.subscribe((data) => {
      this.isSessionAvailable = data['session'];
      this.user = this.sessionService.getUser().firstname;
    });

    this.sessionService.storageData.subscribe(() => {
      if (!this.dataService.data.resetPassword) {
        this.trustiiService.autoLogin().subscribe(
          (res) => {},
          (err) => {
            if (
              !err.error.error.code ||
              'reset_password' !== err.error.error.code
            ) {
              if (!this.dataService.data.resetPassword) {
                this.logout();
              }
            }
          }
        );
      }
    });
  }

  gotoPrivacy() {
    this.router.navigateByUrl(this.isDs ? 'privacy' : 'privacy-organisation');
  }

  gotoTransparency() {
    this.router.navigateByUrl('transparency');
  }

  gotoHome() {
    this.router.navigateByUrl('');
  }

  gotoTerms() {
    window.open('/assets/pdf/TRUSTII-Conditions Générales de Prestation de Services.pdf');
  }

  /**
   * Check if we display sidebar or not by default
   *
   * @return void
   */
  sidebarDisplayByUserAgent(): void {
    // Get real size
    const width: number = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    const height: number = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );

    // Check resolution
    if (width < 1080) {
      this.sidebar = 'mobile';
    } else if (height > width || width < 1280) {
      this.sidebar = 'tablet';
    } else {
      this.sidebar = 'desktop';
    }
  }

  openNotebook() {
    this.trustiiService.getUserNotebook().subscribe(
      (res) => {
        window.open(res.data.url + '?token=' + res.data.token);
      },
      (err) => {
        if (err.error.error.code === 'limit_reached') {
          this.dialogService.openAlertDialog(
            '350px',
            'You have reached your notebook consumption time for today.',
            'Notebook consumption limit reached',
            'Close',
            'modal-warning'
          );
        } else {
          this.dialogService.openAlertDialog(
            '350px',
            'failed to create a session on JupyterHub, please contact our support team.',
            'ERROR',
            'Close',
            'modal-warning'
          );
        }
      }
    );
  }

  logout() {
    this.trustiiService.logout().subscribe(
      (res) => {
        this.sessionService.setToken(null);
        this.sessionService.setUserType(null);
        localStorage.clear();
        this.sessionService.tokenData.next({ session: false });
        this.router.navigateByUrl('/home', { skipLocationChange: false });
      },
      (err) => {}
    );
  }
}
